import PropTypes from "prop-types";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../../styles/createTest/AddAudience.css";

export default class AddAudienceHeader extends React.PureComponent {
    static propTypes = {
        title: PropTypes.string.isRequired,
        iconNames: PropTypes.arrayOf(PropTypes.string).isRequired
    };

    render() {
        return (
            <div className={styles.audienceHeader}>
                <h3>
                    {this.props.iconNames.map(iconName => (
                        <FontAwesomeIcon
                            key={iconName}
                            icon={iconName}
                            className={styles.headerIcon}
                        />
                    ))}
                    {this.props.title}
                </h3>
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateTest/AddAudienceHeader.js